
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Tooltip, Dialog, DialogActions, DialogContent, DialogTitle, TextField, MenuItem } from "@mui/material";
import { useState, useEffect } from "react";
import CustomLoading from "../../../Components/Loading/CustomLoading";
import CustomPagination from "../../../Components/Pagination/Pagination";
import { ReactComponent as EditIcon } from '../../../../Asset/edit-button.svg';
import groupService from "../Shared/GroupService";

const headers = ["STT", "Tên trạm đo", "Tọa độ", "Danh sách cảm biến", "Thời gian cập nhật"];
const metricOptions = [
    { label: "Mực nước", value: "WA" },
    { label: "Đo mở cống", value: "DR" },
    { label: "Đo mưa", value: "RA" }
];

const ListBox = ({ group, boxes, isLoading, onBoxUpdated }) => {
    const [isAdmin, setIsAdmin] = useState(false);
    const [page, setPage] = useState(0);
    const [editingBox, setEditingBox] = useState(null);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [form, setForm] = useState({ name: "", lat: "", lng: "", metrics: [] });
    const [errors, setErrors] = useState({});
    const [isSaving, setIsSaving] = useState(false);
    const [saveError, setSaveError] = useState("");
    const rowsPerPage = 15;
    const visibleBoxes = boxes.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    const tableHeaders = isAdmin ? [...headers, "Hành động"] : headers;

    console.log('group', group.id, group.zone_id)

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"));
        if (user?.role === "admin") {
            setIsAdmin(true);
        }
    }, [])

    const openForm = (box = null) => {
        const location = box?.location || box?.center || {};
        setEditingBox(box);
        setForm({
            name: box?.name || "",
            lat: location.lat ?? "",
            lng: location.lng ?? "",
            metrics: box?.metrics?.map(metric => ({ ...metric })) || []
        });
        setErrors({});
        setSaveError("");
        setIsFormOpen(true);
    };

    const handleClose = () => {
        setIsFormOpen(false);
        setEditingBox(null);
        setErrors({});
        setSaveError("");
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setForm(current => ({ ...current, [name]: value }));
        setErrors(current => ({ ...current, [name]: "" }));
    };

    const handleMetricChange = (index, field, value) => {
        setForm(current => ({
            ...current,
            metrics: current.metrics.map((metric, metricIndex) =>
                metricIndex === index ? { ...metric, [field]: value } : metric
            )
        }));
    };

    const handleAddMetric = () => {
        setForm(current => ({
            ...current,
            metrics: [
                ...current.metrics,
                { name: "", code: "", metric: metricOptions[0].value, warning1: "", warning2: "", warning3: "" }
            ]
        }));
    };

    const handleDeleteMetric = (index) => {
        setForm(current => ({
            ...current,
            metrics: current.metrics.filter((_, metricIndex) => metricIndex !== index)
        }));
    };

    const handleSave = () => {
        const nextErrors = {};
        if (!form.name.trim()) nextErrors.name = "Vui lòng nhập tên trạm đo.";
        if (form.lat === "" || !Number.isFinite(Number(form.lat))) {
            nextErrors.lat = "Vĩ độ phải là số.";
        }
        if (form.lng === "" || !Number.isFinite(Number(form.lng))) {
            nextErrors.lng = "Kinh độ phải là số.";
        }
        if (Object.keys(nextErrors).length > 0) {
            setErrors(nextErrors);
            return;
        }

        setIsSaving(true);
        setSaveError("");
        const payload = {
            name: form.name.trim(),
            location: {
                lat: Number(form.lat),
                lng: Number(form.lng)
            },
            metrics: form.metrics
        };
        const request = editingBox
            ? groupService.updateBox(editingBox.id, payload)
            : groupService.createBox({
                ...payload,
                group_id: group.id,
                zone_id: group.zone_id,
                device_id: group.id + group?.boxs?.length + Date.now()
            });

        request.then(() => {
            onBoxUpdated?.();
            handleClose();
        }).catch(error => {
            const message = error.response?.data?.error || error.message || "Không thể cập nhật trạm đo.";
            setSaveError(`${editingBox ? "Chỉnh sửa" : "Thêm mới"} trạm đo thất bại: ${message}`);
        }).finally(() => setIsSaving(false));
    };

    return (
        <>
        <Paper sx={{ overflow: "hidden" }} elevation={8}>
            <Grid xs={12} sx={{ margin: { xs: '10px' } }} className="end create-button" >
                {isAdmin && <Button variant="contained" onClick={() => openForm()} >Thêm mới</Button>}
            </Grid>
            <TableContainer className="table-zone">
                <Table stickyHeader>
                    <TableHead className="text-bold upper">
                        <TableRow>
                            {tableHeaders.map(header => (
                                <TableCell key={header}
                                    sx={{
                                        fontWeight: "bold",
                                        textTransform: 'uppercase',
                                        fontSize: 14,
                                        color: "#606060"
                                    }}
                                    align="left">{header}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {isLoading
                            ? <CustomLoading numbers={tableHeaders.length} />
                            : boxes.length > 0
                                ? visibleBoxes.map((box, index) => (
                                    <TableRow
                                        key={box.id} hover>
                                        <TableCell sx={{
                                            paddingTop: 4,
                                            paddingBottom: 4,
                                        }} component="th" scope="row">{page * rowsPerPage + index + 1}</TableCell>
                                        <TableCell align="left">{box.name}</TableCell>
                                        {/* <TableCell align="left">{box.desc || ""}</TableCell> */}
                                        <TableCell align="left">
                                            {box.location?.lat ?? box.center?.lat}, {box.location?.lng ?? box.center?.lng}
                                        </TableCell>
                                        <TableCell align="left">{box.metrics?.map((metric) => metric.name).join(", ")}</TableCell>
                                        <TableCell align="left">{new Date(box.mtime).toLocaleString('vi-VN')}</TableCell>
                                        {isAdmin && <TableCell align="left">
                                            <Tooltip title="Chỉnh sửa thông tin" onClick={() => openForm(box)} className="pointer"><EditIcon /></Tooltip>
                                        </TableCell>}
                                    </TableRow>
                                ))
                                : <TableRow>
                                    <TableCell colSpan={tableHeaders.length} align="center">
                                        Không có dữ liệu box.
                                    </TableCell>
                                </TableRow>}
                    </TableBody>
                </Table>
            </TableContainer>
            <Grid container sx={{ p: "1%", ml: "1%" }}>
                <CustomPagination
                    data={boxes}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    parentCallBack={setPage}
                />
            </Grid>
        </Paper>
        <Dialog open={isFormOpen} onClose={handleClose} fullWidth maxWidth="md">
            <DialogTitle>{editingBox ? "Chỉnh sửa thông tin trạm đo" : "Thêm mới trạm đo"}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    fullWidth
                    margin="normal"
                    label="Tên trạm đo"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    error={Boolean(errors.name)}
                    helperText={errors.name}
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="Vĩ độ"
                    name="lat"
                    value={form.lat}
                    onChange={handleChange}
                    error={Boolean(errors.lat)}
                    helperText={errors.lat}
                    inputProps={{ inputMode: "decimal" }}
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="Kinh độ"
                    name="lng"
                    value={form.lng}
                    onChange={handleChange}
                    error={Boolean(errors.lng)}
                    helperText={errors.lng}
                    inputProps={{ inputMode: "decimal" }}
                />
                <div className="metrics-form">
                    <p>Cảm biến</p>
                    {form.metrics.map((metric, index) => (
                        <div className="metric-form-row" key={index}>
                            <TextField
                                fullWidth
                                margin="normal"
                                label="Tên cảm biến"
                                value={metric.name || ""}
                                onChange={event => handleMetricChange(index, "name", event.target.value)}
                            />
                            <TextField
                                fullWidth
                                margin="normal"
                                label="Mã cảm biến"
                                value={metric.code || ""}
                                onChange={event => handleMetricChange(index, "code", event.target.value)}
                            />
                            <TextField
                                select
                                fullWidth
                                margin="normal"
                                label="Loại cảm biến"
                                value={metric.metric || metricOptions[0].value}
                                onChange={event => handleMetricChange(index, "metric", event.target.value)}
                            >
                                {metricOptions.map(option => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                            <Button
                                type="button"
                                color="error"
                                onClick={() => handleDeleteMetric(index)}
                            >
                                Xoá
                            </Button>
                        </div>
                    ))}
                    <Button type="button" variant="outlined" onClick={handleAddMetric}>
                        + Thêm cảm biến
                    </Button>
                </div>
                {saveError && <p className="color-red">{saveError}</p>}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={isSaving}>Huỷ</Button>
                <Button onClick={handleSave} variant="contained" disabled={isSaving}>Lưu</Button>
            </DialogActions>
        </Dialog>
        </>
    );
}

export default ListBox;